// Sample data for Gantt Chart Demo
export const sampleResources = [
  { id: 'r1', name: 'Alice Johnson', avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop', csr: 450 },
  { id: 'r2', name: 'Marco Rossi', avatar: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop', csr: 420 },
  { id: 'r3', name: 'Sara Bianchi', avatar: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop', csr: 400 },
  { id: 'r4', name: 'Luca Ferrari', avatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop', csr: 480 },
  { id: 'r5', name: 'Elena Conti', avatar: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop', csr: 380 },
];

export const sampleProjects = [
  { 
    id: 'p1', 
    name: 'Website Redesign', 
    startDate: '2026-01-06', 
    endDate: '2026-02-28',
    color: '#4F46E5', // Indigo
    saleAmount: 32000,
    estimatedRealDays: 42
  },
  { 
    id: 'p2', 
    name: 'Mobile App Launch', 
    startDate: '2026-01-13', 
    endDate: '2026-03-31',
    color: '#7C3AED', // Violet
    saleAmount: 54000,
    estimatedRealDays: 68
  },
  { 
    id: 'p3', 
    name: 'Marketing Campaign', 
    startDate: '2026-02-01', 
    endDate: '2026-03-15',
    color: '#059669', // Emerald
    saleAmount: 18000,
    estimatedRealDays: 24
  },
];

export const sampleTasks = [
  // Website Redesign Tasks
  { 
    id: 't1', 
    projectId: 'p1', 
    name: 'Design System', 
    startDate: '2026-01-06', 
    endDate: '2026-01-17', 
    progress: 75,
    resourceAllocations: [
      { resourceId: 'r1', weeklyHours: { '2026-W02': 20, '2026-W03': 20 } },
      { resourceId: 'r3', weeklyHours: { '2026-W02': 15, '2026-W03': 10 } },
    ]
  },
  { 
    id: 't2', 
    projectId: 'p1', 
    name: 'Frontend Development', 
    startDate: '2026-01-13', 
    endDate: '2026-02-07', 
    progress: 40,
    resourceAllocations: [
      { resourceId: 'r2', weeklyHours: { '2026-W03': 30, '2026-W04': 35, '2026-W05': 35, '2026-W06': 20 } },
      { resourceId: 'r4', weeklyHours: { '2026-W03': 20, '2026-W04': 25, '2026-W05': 25, '2026-W06': 15 } },
    ]
  },
  { 
    id: 't3', 
    projectId: 'p1', 
    name: 'Backend Integration', 
    startDate: '2026-01-27', 
    endDate: '2026-02-14', 
    progress: 15,
    resourceAllocations: [
      { resourceId: 'r2', weeklyHours: { '2026-W05': 10, '2026-W06': 25, '2026-W07': 30 } },
    ]
  },
  { 
    id: 't4', 
    projectId: 'p1', 
    name: 'Testing & QA', 
    startDate: '2026-02-09', 
    endDate: '2026-02-28', 
    progress: 0,
    resourceAllocations: [
      { resourceId: 'r5', weeklyHours: { '2026-W07': 20, '2026-W08': 35, '2026-W09': 30 } },
    ]
  },
  // Mobile App Launch Tasks
  { 
    id: 't5', 
    projectId: 'p2', 
    name: 'UX Research', 
    startDate: '2026-01-13', 
    endDate: '2026-01-24', 
    progress: 100,
    resourceAllocations: [
      { resourceId: 'r3', weeklyHours: { '2026-W03': 25, '2026-W04': 25 } },
    ]
  },
  { 
    id: 't6', 
    projectId: 'p2', 
    name: 'App Wireframes', 
    startDate: '2026-01-20', 
    endDate: '2026-02-07', 
    progress: 60,
    resourceAllocations: [
      { resourceId: 'r1', weeklyHours: { '2026-W04': 30, '2026-W05': 30, '2026-W06': 20 } },
    ]
  },
  { 
    id: 't7', 
    projectId: 'p2', 
    name: 'iOS Development', 
    startDate: '2026-02-03', 
    endDate: '2026-03-14', 
    progress: 20,
    resourceAllocations: [
      { resourceId: 'r4', weeklyHours: { '2026-W06': 30, '2026-W07': 40, '2026-W08': 40, '2026-W09': 40, '2026-W10': 35, '2026-W11': 25 } },
    ]
  },
  { 
    id: 't8', 
    projectId: 'p2', 
    name: 'Android Development', 
    startDate: '2026-02-10', 
    endDate: '2026-03-21', 
    progress: 10,
    resourceAllocations: [
      { resourceId: 'r2', weeklyHours: { '2026-W07': 15, '2026-W08': 35, '2026-W09': 40, '2026-W10': 40, '2026-W11': 35, '2026-W12': 25 } },
    ]
  },
  { 
    id: 't9', 
    projectId: 'p2', 
    name: 'App Store Launch', 
    startDate: '2026-03-16', 
    endDate: '2026-03-31', 
    progress: 0,
    resourceAllocations: [
      { resourceId: 'r5', weeklyHours: { '2026-W12': 20, '2026-W13': 30, '2026-W14': 15 } },
    ]
  },
  // Marketing Campaign Tasks
  { 
    id: 't10', 
    projectId: 'p3', 
    name: 'Strategy Planning', 
    startDate: '2026-02-02', 
    endDate: '2026-02-13', 
    progress: 50,
    resourceAllocations: [
      { resourceId: 'r5', weeklyHours: { '2026-W06': 20, '2026-W07': 25 } },
    ]
  },
  { 
    id: 't11', 
    projectId: 'p3', 
    name: 'Content Creation', 
    startDate: '2026-02-09', 
    endDate: '2026-02-28', 
    progress: 30,
    resourceAllocations: [
      { resourceId: 'r3', weeklyHours: { '2026-W07': 15, '2026-W08': 25, '2026-W09': 25 } },
      { resourceId: 'r1', weeklyHours: { '2026-W07': 10, '2026-W08': 15, '2026-W09': 10 } },
    ]
  },
  { 
    id: 't12', 
    projectId: 'p3', 
    name: 'Campaign Launch', 
    startDate: '2026-03-02', 
    endDate: '2026-03-15', 
    progress: 0,
    resourceAllocations: [
      { resourceId: 'r5', weeklyHours: { '2026-W10': 30, '2026-W11': 35 } },
    ]
  },
];

// Helper function to generate unique IDs
export const generateId = (prefix) => `${prefix}${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
